// 第5张
const imgAll5 = {
    JP: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724642305015/a5.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1724642845182/c5.jpg',
    },
    NA: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724642305015/a5.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1724642845182/c5.jpg',
    },
    EU: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725092258029/a5.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725092747599/b5.jpg',
    },
    UK: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725093141601/uk5.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725093604860/uk5.jpg',
    },
};
export const imgLocale5: any = {
    jp: imgAll5.JP,
    us: imgAll5.NA,
    ca: imgAll5.NA,
    br: imgAll5.NA,
    mx: imgAll5.NA,
    uk: imgAll5.UK,
    eu: imgAll5.EU,
    de: imgAll5.EU,
    fr: imgAll5.EU,
    it: imgAll5.EU,
    es: imgAll5.EU,
};
